export const QA_STATUS = [
    {
        value: "verified",
        label: "Verified",
    },
    {
        value: "unverified",
        label: "Unverified",
    },
    {
        value: "pending_verification",
        label: "Pending Verification",
    },
];